module.exports = __webpack_public_path__ + "img/44.39fb990a.png";